<InactivityModal />

<!-- App shell: navbar + sidebar fixed; only content scrolls -->
<div class="vh-100 d-flex flex-column bg-gray overflow-hidden">

  <!-- Navbar (same component & behavior) -->
  <Navbar
    @sidebar-toggle="toggleSidebar"
    class="navbar navbar-expand-lg sticky-top bg-white border-bottom w-100 p-0 m-0">
  </Navbar>

  
  <Sidebar variant="mobile" offcanvas_id="dashboardSidebarOffcanvas" />
<!-- Main area below navbar fills remaining height -->
  <div class="container-fluid flex-grow-1 overflow-hidden">
    <div class="row h-100">

      <!-- Sidebar column (same Sidebar component; no scrolling) -->
      <div class="col-auto bg-white h-100 d-none d-lg-block rounded-end mt-2">
        <div class="mt-2">
          <Sidebar ref="sidebar"></Sidebar>
        </div>
      </div>

      <!-- Content column (the ONLY scrollable area) -->
      <div class="col h-100 overflow-auto mt-2">
        <div class="visitor-card shadow border-primary">
          <div class="card-body">
            <button
          class="btn btn-light border rounded-circle d-inline-flex d-lg-none align-items-center justify-content-center p-0 dashboard-workspace-menu me-2 mb-2"
          type="button"
          data-bs-toggle="offcanvas"
          data-bs-target="#dashboardSidebarOffcanvas"
          aria-controls="dashboardSidebarOffcanvas"
          aria-label="Open workspace menu"
        >
          <i class="bx bx-menu-alt-left fs-5"></i>
        </button>

            <div v-show="isLoading" class="text-center py-5 w-100">
              <div class="spinner-border text-secondary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
              <p class="mt-2 mb-0 text-muted text-xxs">Loading Section List...</p>
            </div>
            <div v-show="!isLoading">
            <!-- ============ WHEN SECTIONS EXIST ============ -->
            <div v-if="sections && sections.length">

              <!-- Actions header -->
              <div class="d-flex justify-content-start align-items-center mb-3">
                <!-- Show create only when there ARE sections -->
                <button
                  class="btn btn-sm btn-primary text-xxs rounded shadow-sm d-none d-sm-inline-flex me-2"
                  data-bs-toggle="modal"
                  data-bs-target="#create_section">
                  <i class="bx bx-plus fs-4"></i> Create Section
                </button>
              
              <button v-if="form_id"
                class="btn btn-primary btn-sm text-xxs rounded shadow-sm d-none d-sm-inline-flex"
                @click="assignToForm"
              >
                Assign Selected Sections
              </button>
            
                <!-- Mobile: offcanvas trigger -->
                <button
                  class="btn btn-sm btn-primary text-xxs rounded shadow-sm d-inline-flex d-sm-none"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#create_section_sheet"
                >
                  <i class="bx bx-plus"></i> Create Section
                </button>
              </div>

              <!-- Desktop: TABLE -->
              <div class="table-responsive">
                  <table class="table table-striped text-xxs mt-3">
                    <thead class="btn-primary text-white">
                      <tr>
                        <th v-if="form_id" class="text-center">Select</th>
                        <th scope="col" class="text-center">#</th>
                        <th scope="col">Section Name</th>
                        <th scope="col" class="text-center">Locked</th>
                        <th scope="col" class="text-center">Actions</th>
                      </tr>
                    </thead>

                    <tbody class="text-black">
                      <tr
                        v-for="(item, index) in sections"
                        :key="item.id"
                        class="border-section"
                      >

                        <!-- Checkbox -->
                        <td v-if="form_id" class="text-center">
                          <input
                            type="checkbox"
                            :value="item.id"
                            v-model="selectedSections"
                          />
                        </td>

                        <!-- Row number -->
                        <th scope="row" class="text-center">{{ index + 1 }}</th>
                        <td>{{ item.name }}</td>
                        <td class="text-center">
                          <span
                            v-if="item.is_locked"
                            class="badge bg-danger text-white"
                          >Locked</span>

                          <span
                            v-else
                            class="badge bg-success text-white"
                          >Unlocked</span>
                        </td>
                        <td class="text-center">
                          <!-- Assign Questions -->
                          <router-link
                            :to="'/assign_questions/' + item.id"
                            class="btn btn-light btn-sm rounded-3 border text-primary mx-1 shadow-sm"
                            role="button"
                            aria-label="Assign questions"
                          >
                            <i class="bi bi-eye me-1"></i>
                            <span class="text-xxs">Assign Questions</span>
                          </router-link>

                          <!-- Edit -->
                          <button
                            class="btn btn-light btn-sm rounded-3 border text-success mx-1 shadow-sm"
                            data-bs-toggle="modal"
                            :data-bs-target="'#edit_section_' + item.id"
                            @click="editSectionName(item)"
                            aria-label="Edit"
                          >
                            <i class="bi bi-pencil-square me-1"></i>
                            <span class="text-xxs">Edit</span>
                          </button>

                          <!-- Delete -->
                          <button
                            @click="deleteSection(item.id)"
                            class="btn btn-light btn-sm rounded-3 border text-danger mx-1 shadow-sm"
                            aria-label="Delete"
                          >
                            <i class="bi bi-trash me-1"></i>
                            <span class="text-xxs">Delete</span>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

            </div>
            <!-- ============ WHEN EMPTY ============ -->
            <div v-else>
              <!-- Desktop empty -->
              <div class="text-center py-5">
                <i class="bi bi-collection display-1 text-muted mb-3" aria-hidden="true"></i>
                <p class="text-muted fs-5 mb-1">No sections yet.</p>
                <p class="text-muted text-xxs mb-3">When you create sections, they will appear here.</p>
                <button
                  class="btn btn-sm btn-primary text-xxs rounded shadow-sm d-none d-sm-inline-flex"
                  data-bs-toggle="modal"
                  data-bs-target="#create_section">
                  Create Section
                </button>
                <!-- Mobile: offcanvas trigger -->
                <button
                  class="btn btn-sm btn-primary text-xxs rounded shadow-sm d-inline-flex d-sm-none"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#create_section_sheet"
                >
                  <i class="bx bx-plus"></i> Create Section
                </button>
              </div>
            </div>
            </div>
          </div>

          </div>
          <!-- Create Section Modal -->
          <div class="modal fade" id="create_section" tabindex="-1" aria-labelledby="create_sectionModalLabel"
            aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
              <div class="modal-content">
                <div class="modal-header bg-primary text-white position-relative">
                  <p class="modal-title text-xxs fw-500" id="exampleModalLabel">Create Section</p>
                  <button
                    type="button"
                    class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
                    data-bs-dismiss="modal"
                    aria-label="Close">
                  </button>
                </div>
                <form @submit.prevent="createSection">
                  <div class="modal-body">
                    <div class="mb-3">
                      <label for="section_name" class="form-label text-xxs fw-500">Section Name <span
                          class="text-danger">*</span></label>
                      <input type="text" class="form-control rounded text-xxs" id="section_name"
                        placeholder="Enter section name" v-model="section_name">
                      <p v-if="errors.section_name" class="text-danger text-xxs mt-1">{{ errors.section_name }}</p>
                    </div>
                    <div class="mb-3">
                      <label class="form-label text-xxs fw-500">Lock section</label>
                      <div class="form-check form-switch mt-1">
                        <input class="form-check-input text-xxs mt-2 me-2" type="checkbox" id="locked_toggle" v-model="is_locked">
                        <label class="form-check-label text-xxs" for="locked_toggle">
                          {{ is_locked ? 'Locked' : 'Unlocked' }}
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button type="submit" class="btn btn-primary text-xxs rounded">Save</button>
                  </div>
                </form>
              </div>
            </div>
          </div>

          <!-- Mobile-only full-height sheet -->
          <div class="offcanvas offcanvas-bottom h-50 d-lg-none"
              tabindex="-1"
              id="create_section_sheet"
              aria-labelledby="create_section_sheet_label">
            <div class="offcanvas-header bg-primary text-white">
              <h6 id="create_section_sheet_label" class="mb-0 text-xxs text-white fw-500">Create Section</h6>
              <button type="button" class="btn-close btn-close-white" data-bs-dismiss="offcanvas" aria-label="Close"></button>
            </div>

            <form @submit.prevent="createSection">
              <div class="offcanvas-body">
                <div class="mb-3">
                  <label for="section_name_m" class="form-label text-xxs fw-500">
                    Section Name <span class="text-danger">*</span>
                  </label>
                  <input id="section_name_m" type="text" class="form-control rounded text-xxs"
                        v-model="section_name" placeholder="Enter section name">
                  <p v-if="errors.section_name" class="text-danger text-xxs mt-1">{{ errors.section_name }}</p>
                </div>

                <div class="mb-3">
                  <label class="form-label text-xxs fw-500">Lock section</label>
                  <div class="form-check form-switch mt-1">
                    <input id="locked_toggle_m" class="form-check-input text-xxs mt-2 me-2" type="checkbox"
                          v-model="is_locked">
                    <label class="form-check-label text-xxs" for="locked_toggle_m">
                      {{ is_locked ? 'Locked' : 'Unlocked' }}
                    </label>
                  </div>
                </div>
              </div>

              <div class="border-top p-2">
                <button type="submit" class="btn btn-primary w-100 text-xxs rounded">Save</button>
              </div>
            </form>
          </div>

          <!-- Edit Section Modal -->
          <div v-for="section in sections" :key="section.id">
            <div
              class="modal fade"
              :id="'edit_section_' + section.id"
              tabindex="-1"
              aria-labelledby="edit_section_modal_label"
              aria-hidden="true"
            >
              <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
              <div class="modal-content">
                <div class="modal-header bg-primary text-white position-relative">
                    <p class="modal-title text-xxs fw-500">Edit Section</p>
                    <button
                      type="button"
                      class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
                      data-bs-dismiss="modal"
                      aria-label="Close">
                    </button>
                  </div>
                  <div class="modal-body">
                    <div class="mb-3">
                      <label class="form-label text-xxs fw-500">
                        Section Name <span class="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        class="form-control rounded text-xxs"
                        v-model="edit_section"
                        placeholder="Enter section name"
                      >
                    </div>
                    <div class="mb-3">
                      <label class="form-label text-xxs fw-500">Lock section</label>
                      <div class="form-check form-switch mt-1">
                        <input class="form-check-input text-xxs mt-2 me-2" type="checkbox" id="locked_toggle" v-model="edit_is_locked">
                        <label class="form-check-label text-xxs" for="locked_toggle">
                          {{ is_locked ? 'Locked' : 'Unlocked' }}
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button @click="editSection(section)" type="submit" class="btn btn-primary text-xxs rounded">Update
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-for="section in sections" :key="'m-' + section.id">
            <!-- Mobile-only full-height sheet -->
            <div
              class="offcanvas offcanvas-bottom h-50 d-lg-none"
              tabindex="-1"
              :id="'edit_section_sheet_' + section.id"
              :aria-labelledby="'edit_section_sheet_label_' + section.id"
            >
              <div class="offcanvas-header bg-primary text-white">
                <h6 class="mb-0 text-xxs fw-500 text-white" :id="'edit_section_sheet_label_' + section.id">
                  Edit Section
                </h6>
                <button type="button" class="btn-close btn-close-white" data-bs-dismiss="offcanvas" aria-label="Close"></button>
              </div>

              <div class="offcanvas-body">
                <div class="mb-3">
                  <label class="form-label text-xxs fw-500">
                    Section Name <span class="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    class="form-control rounded text-xxs"
                    v-model="edit_section"
                    placeholder="Enter section name"
                  >
                </div>

                <div class="mb-3">
                  <label class="form-label text-xxs fw-500">Lock section</label>
                  <div class="form-check form-switch mt-1">
                    <input
                      class="form-check-input text-xxs mt-2 me-2"
                      type="checkbox"
                      :id="'edit_locked_toggle_m_' + section.id"
                      v-model="edit_is_locked">
                    <label class="form-check-label text-xxs" :for="'edit_locked_toggle_m_' + section.id">
                      {{ edit_is_locked ? 'Locked' : 'Unlocked' }}
                    </label>
                  </div>
                </div>
              </div>

              <div class="border-top p-2">
                <button @click="editSection(section)" type="button" class="btn btn-primary w-100 text-xxs rounded">
                  Update
                </button>
              </div>
            </div>
          </div>

      </div>
    </div>
  </div>
</div>